"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _helpers = require("@qwkin/helpers");
var _core = require("@material-ui/core");
var _styledComponents = require("styled-components");
var _FormField = require("../FormField/FormField.styles");
var _theme = require("../utils/theme");
var _excluded = ["items", "icon", "theme", "helperText", "autoComplete", "options", "getOptionLabel", "onChange", "value", "label", "showChips", "displayFullList", "displayValueTransformer"],
  _excluded2 = ["theme", "rowsMax", "children", "margin", "variant", "items", "mask", "value", "disabled", "maskChar", "alwaysShowMask", "icon", "helperText", "label", "onChange", "autoComplete", "options", "getOptionLabel", "multiple", "displayValueTransformer", "showChips"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BaseFormField = function BaseFormField(_ref) {
  var items = _ref.items,
    icon = _ref.icon,
    theme = _ref.theme,
    helperText = _ref.helperText,
    autoComplete = _ref.autoComplete,
    options = _ref.options,
    getOptionLabel = _ref.getOptionLabel,
    _onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    label = _ref.label,
    _ref$showChips = _ref.showChips,
    showChips = _ref$showChips === void 0 ? false : _ref$showChips,
    displayFullList = _ref.displayFullList,
    displayValueTransformer = _ref.displayValueTransformer,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedItems = _useState2[0],
    setSelectedItems = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_FormField.FormFieldWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    margin: "dense",
    variant: "outlined",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, null, label), /*#__PURE__*/_react["default"].createElement(_Select["default"], (0, _extends2["default"])({}, params, {
    multiple: true,
    style: {
      width: '100%'
    },
    value: selectedItems,
    onChange: function onChange(v) {
      setSelectedItems((0, _toConsumableArray2["default"])(v.target.value));
      _onChange(v);
    },
    label: label,
    input: /*#__PURE__*/_react["default"].createElement(_OutlinedInput["default"], {
      style: {
        width: '100%'
      },
      margin: "dense",
      label: label
    }),
    renderValue: function renderValue(selected) {
      if (showChips) {
        return /*#__PURE__*/_react["default"].createElement(_core.Box, {
          sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px'
          }
        }, selected.map(function (value) {
          return /*#__PURE__*/_react["default"].createElement(_core.Chip, {
            key: displayValueTransformer(value),
            label: displayValueTransformer(value)
          });
        }));
      } else if (displayFullList) {
        return selected.map(function (value) {
          return displayValueTransformer(value);
        }).join(', ');
      }
      return "".concat(displayValueTransformer(selected[0])).concat(selected.length > 1 ? ", +".concat(selected.length - 1) : '');
    }
  }), items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      size: "small",
      dense: true,
      key: JSON.stringify(item),
      value: item,
      style: {
        padding: '0 4px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      size: "small",
      color: "primary",
      checked: selectedItems.findIndex(function (v) {
        return JSON.stringify(v) === JSON.stringify(item);
      }) !== -1
    }), displayValueTransformer(item));
  }))));
};
var SelectableFormField = function SelectableFormField(_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? _theme.defaultTheme : _ref2$theme,
    rowsMax = _ref2.rowsMax,
    children = _ref2.children,
    margin = _ref2.margin,
    variant = _ref2.variant,
    items = _ref2.items,
    mask = _ref2.mask,
    value = _ref2.value,
    disabled = _ref2.disabled,
    maskChar = _ref2.maskChar,
    alwaysShowMask = _ref2.alwaysShowMask,
    icon = _ref2.icon,
    helperText = _ref2.helperText,
    label = _ref2.label,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? _helpers.identity : _ref2$onChange,
    autoComplete = _ref2.autoComplete,
    options = _ref2.options,
    getOptionLabel = _ref2.getOptionLabel,
    multiple = _ref2.multiple,
    _ref2$displayValueTra = _ref2.displayValueTransformer,
    displayValueTransformer = _ref2$displayValueTra === void 0 ? _helpers.identity : _ref2$displayValueTra,
    _ref2$showChips = _ref2.showChips,
    showChips = _ref2$showChips === void 0 ? false : _ref2$showChips,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(BaseFormField, (0, _extends2["default"])({
    items: items,
    value: value,
    onChange: autoComplete ? onChange : function (e) {
      return onChange(e.target.value);
    },
    disabled: disabled,
    icon: icon,
    theme: theme,
    helperText: helperText,
    multiple: multiple,
    options: options,
    label: label,
    getOptionLabel: getOptionLabel,
    displayValueTransformer: displayValueTransformer,
    showChips: showChips
  }, params)));
};
var _default = exports["default"] = SelectableFormField;